export const communityCategory: any = [
	{key: "all", label: "전체"},
	{key: "event", label: "이벤트 공지"},
	{key: "review", label: "투어후기"},
	{key: "party", label: "투어동행찾기"},
	{key: "request", label: "단체투어문의"},
	{key: "qna", label: "Q & A"}
];
